import React from "react";
import { Button, Message, Segment } from "semantic-ui-react";
import { startGetSignatureFields } from "../../../store/actions/core/email-signature/signature";

import { connect } from "react-redux";
import { toast } from "react-semantic-toasts";
import constants from "../../../utils/constants";
import { checkLinkedin } from "../../../utils/stringUtils";
import VCardWallet from "./VCardWallet";

// Vecchia gestione logo, comune per tutte le company
// const logo = process.env.REACT_APP_IMAGE_LOGO_BUCKET + "avvale-logo.png";

const iconLinkedin = process.env.REACT_APP_IMAGE_LOGO_BUCKET + "pictures/linkedin.png";
const iconPhone = process.env.REACT_APP_IMAGE_LOGO_BUCKET + "pictures/phone.png";
const iconEmail = process.env.REACT_APP_IMAGE_LOGO_BUCKET + "pictures/mail.png";
const iconWeb = process.env.REACT_APP_IMAGE_LOGO_BUCKET + "pictures/web.png";

// AEP-126 Email Logos
// The logged-in user sees a different logo depending on their company.
//
// Fix AEP-9769:: the mapping uses company_code (stable across environments) instead of
// company_id, which may differ between dev/test/prod when DB snapshots get out of sync.
// The map only contains companies that do NOT use the default Avvale logo; any other code
// (including unknown or null values) falls back to DEFAULT_LOGO_FILENAME.

const DEFAULT_LOGO_FILENAME = "avvale-logo.png";
const LOGO_FILENAME_BY_COMPANY_CODE = {
  ESGEO: "esgeo-logo.png",
  REWIS: "reportwise-logo.png",
};

class EmailSignature extends React.Component {
  constructor(props) {
    super(props);
  }
  /**
   * Resolves the logo URL for the given company code.
   * Falls back to the default Avvale logo when the code is unknown, null, or undefined.
   *
   * @param {string} companyCode - Company code (e.g., 'REWIS', 'ESGEO').
   * @returns {string} Absolute URL to the logo image in the assets bucket.
   */
  getLogoUrl = (companyCode) => {
    const filename = LOGO_FILENAME_BY_COMPANY_CODE[companyCode] || DEFAULT_LOGO_FILENAME;
    return process.env.REACT_APP_IMAGE_LOGO_BUCKET + filename;
  };

  componentDidMount() {
    this.props.getSignatureFields();
    // console.log('User Company ID: ', this.props.company);
    //console.log('props',this.props.fields.linkedin)
  }
  componentDidUpdate() {

  }

  onCopy = () => {
    //console.log('props',this.props.fields)
    const doc = document;

    const text = doc.getElementById("signature");

    let range;
    let selection;

    if (doc.body.createTextRange) {
      range = doc.body.createTextRange();
      range.moveToElement(text);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();

      range = doc.createRange();
      range.selectNodeContents(text);

      selection.removeAllRanges();
      selection.addRange(range);
    }

    try {
      if (document.execCommand("copy", false, null)) {
        toast({
          title: "Email Signature",
          description: "Signature copied!",
          icon: "envelope",
          type: "success",
          time: constants.TOAST_SUCCESS_TIMEOUT,
          animation: "fly left",
        });
        selection.removeAllRanges();
      }
    } catch (e) {
      toast({
        title: "Email Signature",
        description: "Cannot copy signature!",
        icon: "envelope",
        type: "error",
        time: constants.TOAST_ERROR_TIMEOUT,
        animation: "fly left",
      });
    }
    window.getSelection().removeAllRanges();
  };


  render() {
    return (
      <Segment style={{ height: "100vh" }} loading={this.props.loading}>
        {!this.props.loading && this.props.failed ? (
          <Message negative size="large">
            <Message.Header>Error during signature creation.</Message.Header>
            <p>The signature cannot be created.</p>
          </Message>
        ) : (
          <div
            className="EmailSignatureComponent"
            style={{
              marginTop: "1.25em",
            }}
          >
            <div id="signature" style={{ backgroundColor: "white" }}>
              <table cellSpacing="0">
                <tbody>
                  <tr>
                    <td valign="top" align="center" style={{ paddingRight: '10px' }}>
                      <a
                        href="http://www.avvale.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          width="180"
                          src={this.getLogoUrl(this.props.companyCode)}
                          id="logoImg"
                          alt="Avvale enabling what's next"
                        />
                      </a>
                    </td>
                    <td
                      valign="center"
                      align="left"
                      style={{
                        borderLeft: "1px solid #d2d3d3",
                        paddingLeft: "10px",
                      }}
                    >
                      <p
                        className='emailSignaturePaddingLeft'
                        style={{
                          fontWeight: "bold",
                          color: "rgb(65, 86, 97)",
                          fontSize: "18px",
                          margin: "0px",
                        }}
                      >
                        {this.props.fields.name}{" "}{this.props.fields.surname}
                      </p>
                      <p
                        className='emailSignaturePaddingLeft'
                        style={{
                          margin: "0",
                          fontSize: "14px",
                          color: "rgb(120, 206, 79)",
                        }}
                      >
                        {this.props.fields.role}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top" align="center">
                      <img
                        width="100"
                        src={this.props.fields.businessQRCodeCardUrl}
                        id='qrImg'
                      />
                    </td>
                    <td
                      valign="top"
                      style={{
                        borderLeft: "1px solid #d2d3d3",
                        paddingLeft: "5px",
                      }}
                    >
                      <table>
                        <tbody>
                          {
                            this.props.fields.phone !== null && this.props.fields.phone !== '' && (<tr>
                              <td valign="center" align="center">
                                <img
                                  className="iconImage"
                                  src={iconPhone}
                                  style={{
                                    verticalAlign: "middle",
                                  }}
                                  alt="Phone"
                                />
                              </td>
                              <td valign="center" align="left">
                                <a
                                  href={"tel:" + this.props.fields.phone}
                                  style={{
                                    color: "#567482",
                                    fontWeight: "regular",
                                    fontSize: "12px",
                                  }}
                                >
                                  <u>{this.props.fields.phone}</u>
                                </a>
                              </td>
                            </tr>)}
                          <tr>
                            <td valign="center" align="center">
                              <img
                                className="iconImage"
                                src={iconEmail}
                                style={{
                                  verticalAlign: "middle",
                                }}
                                alt="Email"
                              />
                            </td>
                            <td valign="center" align="left">
                              <a
                                href={"mailto:" + this.props.fields.email}
                                style={{
                                  color: "#567482",
                                  fontWeight: "regular",
                                  fontSize: "12px",
                                }}
                              >
                                <u>{this.props.fields.email}</u>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            {this.props.fields.linkedin !== null && this.props.fields.linkedin !== "" && (<td valign="center" align="center">
                              <img
                                className="iconImage"
                                src={iconLinkedin}
                                style={{
                                  verticalAlign: "middle",
                                }}
                                alt="Linkedin"
                              />
                            </td>)}
                            <td valign="center" align="left">
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={'https://' + checkLinkedin(this.props.fields.linkedin)}
                                style={{
                                  color: "#567482",
                                  fontWeight: "regular",
                                  fontSize: "12px",
                                }}
                              >
                                <u>{checkLinkedin(this.props.fields.linkedin)}</u>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td valign="center" align="center">
                              <img
                                src={iconWeb}
                                className="iconImage"
                                style={{
                                  verticalAlign: "middle",
                                }}
                              />
                            </td>
                            <td valign="center" align="left">
                              <a
                                href="http://www.avvale.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  fontWeight: "bold",
                                  color: "#5ab031",
                                  fontSize: "12px",
                                }}
                              >
                                <u>www.avvale.com</u>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {window.innerWidth > 600 ? (
              <Button
                fluid
                style={{
                  marginTop: "2em",
                  fontWeight: "bold",
                  fontSize: "1.12em",
                }}
                onClick={this.onCopy}
              >
                Copy Signature
              </Button>
            ) : <VCardWallet />}
          </div>
        )}
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user ? state.authReducer.user.attributes : null,
    loading: state.emailSignatureReducer.loading,
    fields: state.emailSignatureReducer.fields,
    failed: state.emailSignatureReducer.failed,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getSignatureFields: () => dispatch(startGetSignatureFields()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailSignature);
